/* =========================================================
   Aether Rift — theme scripts (no dependencies)
   ========================================================= */
(function () {
  'use strict';

  const AR = window.AetherRift || { routes: {}, strings: {} };
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const root = (AR.routes.root || '/').replace(/\/$/, '');

  /* ---------- storage (fails quietly in private mode) ---------- */
  const store = {
    get(key, fallback) {
      try { const v = localStorage.getItem('ar:' + key); return v === null ? fallback : JSON.parse(v); }
      catch (e) { return fallback; }
    },
    set(key, value) { try { localStorage.setItem('ar:' + key, JSON.stringify(value)); } catch (e) { /* ignore */ } }
  };

  /* ---------- money ---------- */
  function formatMoney(cents) {
    const fmt = AR.moneyFormat || '${{amount}}';
    const value = (Number(cents) || 0) / 100;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      if (key === 'amount_no_decimals') return Math.round(value).toLocaleString('en-US');
      if (key === 'amount_with_comma_separator') return value.toFixed(2).replace('.', ',');
      return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  }

  /* ---------- toast ---------- */
  let toastTimer;
  function toast(message, isError) {
    const el = $('#RiftToast');
    if (!el) return;
    el.textContent = message;
    el.classList.toggle('is-error', !!isError);
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 3200);
  }

  /* ---------- cart ---------- */
  async function refreshCartCount() {
    try {
      const res = await fetch(root + '/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      return cart;
    } catch (e) { return null; }
  }

  async function addToCart(items) {
    const res = await fetch(root + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || AR.strings.error);
    await refreshCartCount();
    return data;
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-ajax-add]');
    if (!form) return;
    event.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const fd = new FormData(form);
    const id = Number(fd.get('id'));
    const quantity = Number(fd.get('quantity') || 1);
    if (!id) return;
    if (btn) btn.setAttribute('aria-disabled', 'true');
    try {
      await addToCart([{ id, quantity }]);
      toast(AR.strings.added || 'Added to cart');
    } catch (err) {
      toast(err.message, true);
    } finally {
      if (btn) btn.removeAttribute('aria-disabled');
    }
  });

  /* ---------- header toggles ---------- */
  function bindToggle(btnSel, targetSel, focusSel) {
    $$(btnSel).forEach((btn) => {
      btn.addEventListener('click', () => {
        const target = $(targetSel);
        if (!target) return;
        const open = !target.classList.contains('is-open');
        target.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', String(open));
        if (open && focusSel) { const f = $(focusSel, target); if (f) f.focus(); }
      });
    });
  }
  bindToggle('.js-menu-toggle', '#MobileNav');
  bindToggle('.js-search-toggle', '#HeaderSearch', 'input[type="search"]');
  bindToggle('.js-facets-toggle', '#Facets');

  /* ---------- predictive search ---------- */
  $$('[data-predictive-search]').forEach((form) => {
    const input = $('input[type="search"]', form);
    const box = $('[data-predictive-results]', form);
    if (!input || !box) return;
    let timer, controller;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { box.hidden = true; return; }
      timer = setTimeout(async () => {
        if (controller) controller.abort();
        controller = new AbortController();
        const params = new URLSearchParams({
          q,
          'resources[type]': 'product,collection',
          'resources[limit]': '8',
          'resources[options][fields]': 'title,product_type,variants.sku,tag,vendor',
          'resources[options][unavailable_products]': 'last'
        });
        try {
          const res = await fetch((AR.routes.predictive_search || root + '/search/suggest') + '.json?' + params, { signal: controller.signal });
          const data = await res.json();
          const r = (data.resources && data.resources.results) || {};
          const cols = (r.collections || []).slice(0, 3).map((c) => `<a class="predictive__item" href="${c.url}"><span class="badge badge--rarity">Set</span><span>${escapeHtml(c.title)}</span><span></span></a>`);
          const prods = (r.products || []).map((p) => {
            const img = p.featured_image && p.featured_image.url ? `<img src="${p.featured_image.url}&width=88" alt="" loading="lazy">` : '<span></span>';
            return `<a class="predictive__item" href="${p.url}">${img}<span>${escapeHtml(p.title)}${p.available ? '' : ' <small class="muted">— ' + (AR.strings.soldOut || 'Sold out') + '</small>'}</span><span class="price">${p.price ? escapeHtml(formatMoney(Math.round(parseFloat(p.price) * 100))) : ''}</span></a>`;
          });
          const html = cols.concat(prods).join('');
          box.innerHTML = html || '<p class="muted" style="padding:.5rem">No matches.</p>';
          box.hidden = false;
        } catch (e) { /* aborted or offline */ }
      }, 220);
    });
    document.addEventListener('click', (e) => { if (!form.contains(e.target)) box.hidden = true; });
  });

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  /* ---------- holo tilt ---------- */
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function bindTilt(el, img) {
    if (reduceMotion || !img) return;
    el.addEventListener('pointermove', (e) => {
      const r = el.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width;
      const y = (e.clientY - r.top) / r.height;
      img.style.transform = `rotateY(${(x - 0.5) * 14}deg) rotateX(${(0.5 - y) * 14}deg) scale(1.03)`;
      el.style.setProperty('--mx', (x * 100) + '%');
      el.style.setProperty('--my', (y * 100) + '%');
    });
    el.addEventListener('pointerleave', () => { img.style.transform = ''; });
  }
  function initTilt(scope = document) {
    $$('.card[data-tilt]', scope).forEach((card) => {
      if (card.dataset.tiltBound) return;
      card.dataset.tiltBound = '1';
      bindTilt(card, $('.card__media img', card));
    });
  }
  initTilt();
  $$('[data-stage-tilt]').forEach((stage) => bindTilt(stage, $('img', stage)));

  /* ---------- countdowns ---------- */
  function tickCountdowns() {
    const now = Date.now();
    $$('[data-countdown]').forEach((el) => {
      const target = Date.parse(el.dataset.countdown);
      if (isNaN(target)) return;
      let diff = Math.max(0, target - now);
      if (diff === 0) {
        el.innerHTML = '<span>' + (el.dataset.liveLabel || 'Out now') + '</span>';
        const row = el.closest('.release');
        if (row) row.classList.add('is-live');
        return;
      }
      const d = Math.floor(diff / 864e5); diff -= d * 864e5;
      const h = Math.floor(diff / 36e5); diff -= h * 36e5;
      const m = Math.floor(diff / 6e4); diff -= m * 6e4;
      const s = Math.floor(diff / 1e3);
      el.innerHTML = `<span>${d}<small>d</small></span><span>${h}<small>h</small></span><span>${m}<small>m</small></span><span>${s}<small>s</small></span>`;
    });
  }
  if ($('[data-countdown]')) { tickCountdowns(); setInterval(tickCountdowns, 1000); }

  /* ---------- collection: ajax filtering ---------- */
  function initCollection(scope = document) {
    const container = $('[data-collection]', scope);
    if (!container) return;
    const sectionId = container.dataset.sectionId;

    async function render(url, push = true) {
      const grid = $('[data-collection]');
      grid.classList.add('is-loading');
      const u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      try {
        const res = await fetch(u.toString());
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        $$('[data-ajax-region]').forEach((region) => {
          const fresh = doc.querySelector(`[data-ajax-region="${region.dataset.ajaxRegion}"]`);
          if (!fresh) return;
          if (region.classList.contains('is-open')) fresh.classList.add('is-open');
          $$('details', region).forEach((d, i) => { const fd = $$('details', fresh)[i]; if (fd) fd.open = d.open; });
          region.replaceWith(fresh);
        });
        u.searchParams.delete('section_id');
        if (push) history.pushState({}, '', u.pathname + u.search);
        afterRender();
      } catch (e) {
        window.location.href = url;
      } finally {
        const g = $('[data-collection]');
        if (g) g.classList.remove('is-loading');
      }
    }

    function urlFromForm(form) {
      const fd = new FormData(form);
      const params = new URLSearchParams();
      for (const [k, v] of fd.entries()) { if (v !== '') params.append(k, v); }
      const sort = $('[data-sort-by]');
      if (sort && sort.value) params.set('sort_by', sort.value);
      return window.location.pathname + '?' + params.toString();
    }

    let debounce;
    document.addEventListener('change', (e) => {
      const form = e.target.closest('[data-facets-form]');
      if (form) {
        clearTimeout(debounce);
        debounce = setTimeout(() => render(urlFromForm(form)), e.target.type === 'number' ? 600 : 50);
        return;
      }
      if (e.target.matches('[data-archive-filter]')) {
        const sel = e.target;
        const u = new URL(window.location.href);
        u.searchParams.delete(sel.dataset.archiveFilter);
        if (sel.dataset.clears) u.searchParams.delete(sel.dataset.clears);
        u.searchParams.delete('page');
        if (sel.value) u.searchParams.append(sel.dataset.archiveFilter, sel.value);
        render(u.toString());
        return;
      }
      if (e.target.matches('[data-sort-by]')) {
        const f = $('[data-facets-form]');
        if (f) render(urlFromForm(f));
        else { const u = new URL(window.location.href); u.searchParams.set('sort_by', e.target.value); render(u.toString()); }
      }
    });

    document.addEventListener('click', (e) => {
      const link = e.target.closest('[data-facet-link], .pagination a');
      if (!link || !$('[data-collection]')) return;
      e.preventDefault();
      render(link.href);
      if (link.closest('.pagination')) window.scrollTo({ top: ($('[data-collection]').getBoundingClientRect().top + window.scrollY) - 120, behavior: 'smooth' });
    });

    window.addEventListener('popstate', () => render(window.location.href, false));
    afterRender();
  }

  /* ---------- views, page-sort, set checklist ---------- */
  const RARITY_RANK = {
    'common': 1, 'c': 1, 'uncommon': 2, 'u': 2, 'rare': 3, 'r': 3, 'holo rare': 4, 'rare holo': 4,
    'double rare': 5, 'rr': 5, 'super rare': 5, 'sr': 6, 'ace spec rare': 6, 'mythic': 6, 'mythic rare': 6, 'm': 6,
    'leader': 5, 'l': 5, 'epic': 5, 'legendary': 6, 'ultra rare': 7, 'ur': 7, 'illustration rare': 7, 'ir': 7,
    'secret rare': 8, 'sec': 8, 'special illustration rare': 9, 'sir': 9, 'alternate art': 9, 'alt art': 9, 'manga': 10,
    'hyper rare': 10, 'hr': 10, 'lr': 9, 'legend rare': 9, 'sr★': 7, 'sr*': 7, 'ssr': 7, 'ur': 7, 'sgr': 8, 'lsr': 9, 'sc': 9, 'xr': 10, 'zr': 10, 'scr': 10, 'enchanted': 10, 'showcase': 8, 'promo': 4, 'p': 4
  };
  const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

  function sortList(list, mode) {
    const items = $$(':scope > [data-item]', list);
    const key = {
      number: (el) => el.dataset.number || '~',
      rarity: (el) => -(RARITY_RANK[(el.dataset.rarity || '').toLowerCase()] || 0),
      name: (el) => el.dataset.name || '',
      'price-asc': (el) => Number(el.dataset.price || 0),
      'price-desc': (el) => -Number(el.dataset.price || 0),
      set: (el) => (el.dataset.set || '') + ' ' + (el.dataset.number || '')
    }[mode];
    if (!key) return;
    items.sort((a, b) => {
      const ka = key(a), kb = key(b);
      return typeof ka === 'number' ? ka - kb : collator.compare(ka, kb);
    }).forEach((el) => list.appendChild(el));
  }

  function updateChecklist(list) {
    const setKey = list.dataset.setKey;
    if (!setKey) return;
    const owned = store.get('owned:' + setKey, []);
    let ownedCount = 0;
    $$(':scope > [data-item]', list).forEach((el) => {
      const is = owned.includes(el.dataset.productId);
      el.classList.toggle('is-owned', is);
      const cb = $('.owned-toggle input', el);
      if (cb) cb.checked = is;
      if (is) ownedCount++;
    });
    const total = Number(list.dataset.setTotal || 0);
    $$('[data-owned-count]').forEach((el) => { el.textContent = ownedCount; });
    $$('[data-owned-bar]').forEach((el) => {
      el.style.width = total ? Math.min(100, (ownedCount / total) * 100) + '%' : '0%';
    });
  }

  function afterRender() {
    const list = $('.product-list');
    initTilt();
    if (!list) return;
    const view = store.get('view:' + (list.dataset.viewScope || 'cards'), list.dataset.view || 'grid');
    setView(list, view);
    const ps = $('[data-page-sort]');
    if (ps && ps.value) sortList(list, ps.value);
    updateChecklist(list);
    const hideOwned = $('[data-hide-owned]');
    if (hideOwned) list.classList.toggle('hide-owned', hideOwned.checked);
  }

  function setView(list, view) {
    if (!$(`[data-view-btn="${view}"]`)) view = 'grid';
    list.dataset.view = view;
    $$('[data-view-btn]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.viewBtn === view)));
    $$('[data-checklist-only]').forEach((el) => { el.hidden = view !== 'checklist'; });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-view-btn]');
    if (!btn) return;
    const list = $('.product-list');
    if (!list) return;
    setView(list, btn.dataset.viewBtn);
    store.set('view:' + (list.dataset.viewScope || 'cards'), btn.dataset.viewBtn);
    if (btn.dataset.viewBtn === 'checklist') { const ps = $('[data-page-sort]'); if (ps) { ps.value = 'number'; sortList(list, 'number'); } }
  });

  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-page-sort]')) {
      const list = $('.product-list');
      if (list) sortList(list, e.target.value);
    }
    if (e.target.matches('.owned-toggle input')) {
      const list = e.target.closest('.product-list');
      const item = e.target.closest('[data-item]');
      if (!list || !item) return;
      const key = 'owned:' + list.dataset.setKey;
      const owned = new Set(store.get(key, []));
      if (e.target.checked) owned.add(item.dataset.productId); else owned.delete(item.dataset.productId);
      store.set(key, Array.from(owned));
      updateChecklist(list);
    }
    if (e.target.matches('[data-hide-owned]')) {
      const list = $('.product-list');
      if (list) list.classList.toggle('hide-owned', e.target.checked);
    }
  });

  initCollection();
  if (!$('[data-collection]')) afterRender();

  /* ---------- archive: card search + set browser in one panel ---------- */
  $$('[data-set-browser]').forEach((browser) => {
    const tiles = $$('[data-set-tile]', browser);
    const grid = $('[data-set-grid]', browser);
    const empty = $('[data-set-empty]', browser);
    const form = $('[data-finder]', browser);
    const fGame = $('[data-finder-game]', browser);
    const fSet = $('[data-finder-set]', browser);
    const fName = $('[data-finder-name]', browser);
    const fFilter = $('[data-set-search]', browser);
    const fSort = $('[data-set-sort]', browser);
    const countEl = $('[data-set-count]', browser);

    // game order + display names come from the Game dropdown (Theme settings → Games)
    const gameOrder = fGame ? $$('option', fGame).map((o) => o.value).filter((v) => v !== 'all') : [];
    const gameName = {};
    if (fGame) $$('option', fGame).forEach((o) => { gameName[o.value] = o.textContent.trim(); });
    const gameRank = (g) => { const i = gameOrder.indexOf(g); return i === -1 ? 999 : i; };

    let game = new URLSearchParams(window.location.search).get('game') || 'all';
    if (fGame && !$(`option[value="${game}"]`, fGame)) game = 'all';

    function visibleTiles() {
      const q = (fFilter && fFilter.value.trim().toLowerCase()) || '';
      return tiles.filter((t) => (game === 'all' || t.dataset.game === game) && (!q || t.dataset.search.includes(q)));
    }

    function compare(mode) {
      const byName = (a, b) => collator.compare(a.dataset.title, b.dataset.title);
      const byNewest = (a, b) => (b.dataset.release || '0000').localeCompare(a.dataset.release || '0000') || byName(a, b);
      const byOldest = (a, b) => (a.dataset.release || '9999').localeCompare(b.dataset.release || '9999') || byName(a, b);
      const byGame = (a, b) => gameRank(a.dataset.game) - gameRank(b.dataset.game) || collator.compare(a.dataset.game, b.dataset.game);
      return {
        'game-name': (a, b) => byGame(a, b) || byName(a, b),
        'game-newest': (a, b) => byGame(a, b) || byNewest(a, b),
        newest: byNewest, oldest: byOldest, name: byName
      }[mode] || byName;
    }

    function render() {
      const mode = fSort ? fSort.value : 'game-name';
      const grouped = mode.startsWith('game-');
      const shown = visibleTiles().sort(compare(mode));
      $$('[data-set-group]', grid).forEach((h) => h.remove());
      tiles.forEach((t) => { t.hidden = true; });
      let lastGame = null;
      shown.forEach((t) => {
        if (grouped && t.dataset.game !== lastGame) {
          lastGame = t.dataset.game;
          const n = shown.filter((x) => x.dataset.game === lastGame).length;
          const h = document.createElement('h2');
          h.className = 'set-era';
          h.dataset.setGroup = '';
          h.innerHTML = `${escapeHtml(gameName[lastGame] || 'Other')} <small class="muted" style="font-family:var(--f-body);font-size:.8rem">${n} set${n === 1 ? '' : 's'}</small>`;
          grid.appendChild(h);
        }
        t.hidden = false;
        grid.appendChild(t);
      });
      if (empty) empty.hidden = shown.length !== 0 || tiles.length === 0;
      if (countEl) countEl.textContent = `${shown.length} set${shown.length === 1 ? '' : 's'}`;
    }

    function fillSets() {
      if (!fSet) return;
      const current = fSet.value;
      const list = tiles.filter((t) => game === 'all' || t.dataset.game === game).slice().sort(compare(game === 'all' ? 'game-name' : 'name'));
      let html = `<option value="">${list.length ? 'Any set (' + list.length + ')' : 'No sets for this game yet'}</option>`;
      let open = null;
      list.forEach((t) => {
        if (game === 'all' && t.dataset.game !== open) {
          if (open !== null) html += '</optgroup>';
          open = t.dataset.game;
          html += `<optgroup label="${escapeHtml(gameName[open] || 'Other')}">`;
        }
        html += `<option value="${t.getAttribute('href')}">${escapeHtml(t.dataset.title)}</option>`;
      });
      if (open !== null) html += '</optgroup>';
      fSet.innerHTML = html;
      if (list.some((t) => t.getAttribute('href') === current)) fSet.value = current;
    }

    function setGame(next) {
      game = next;
      const u = new URL(window.location.href);
      if (game === 'all') u.searchParams.delete('game'); else u.searchParams.set('game', game);
      history.replaceState({}, '', u);
      if (fGame) fGame.value = game;
      fillSets();
      render();
    }

    if (fGame) fGame.addEventListener('change', () => setGame(fGame.value));
    if (fSet) fSet.addEventListener('change', () => { if (fSet.value && !(fName && fName.value.trim())) window.location.href = fSet.value; });
    if (fFilter) fFilter.addEventListener('input', render);
    if (fSort) fSort.addEventListener('change', render);

    if (form) form.addEventListener('submit', (e) => {
      const name = fName ? fName.value.trim() : '';
      if (name) return; // search the store for the card name
      e.preventDefault();
      if (fSet && fSet.value) { window.location.href = fSet.value; return; }
      grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    if (fGame) fGame.value = game;
    fillSets();
    render();
  });

  /* ---------- product page ---------- */
  $$('[data-product]').forEach((root) => {
    const dataEl = $('script[data-variants]', root);
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const form = $('form[data-product-form]', root);
    const idInput = $('input[name="id"]', form);
    const priceEl = $('[data-price]', root);
    const btn = $('[data-add-btn]', root);
    const stockEl = $('[data-stock]', root);
    const lowStock = Number(root.dataset.lowStock || 3);
    const isPreorder = root.dataset.preorder === 'true';

    function selectedOptions() {
      return $$('[data-option-index]', root).map((group) => {
        const checked = $('input:checked', group);
        return checked ? checked.value : null;
      });
    }

    function update() {
      const opts = selectedOptions();
      const v = variants.find((x) => x.options.every((o, i) => o === opts[i]));
      // mark unavailable combos
      $$('[data-option-index]', root).forEach((group) => {
        const idx = Number(group.dataset.optionIndex);
        $$('input', group).forEach((input) => {
          const test = opts.slice(); test[idx] = input.value;
          const match = variants.find((x) => x.options.every((o, i) => o === test[i]));
          const label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !match || !match.available);
          const sub = label && label.querySelector('small');
          if (sub && match) sub.textContent = formatMoney(match.price);
        });
      });
      if (!v) {
        btn.disabled = true; btn.textContent = btn.dataset.unavailable;
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = formatMoney(v.price) + (v.compare_at_price > v.price ? ` <s>${formatMoney(v.compare_at_price)}</s>` : '');
      btn.disabled = !v.available;
      btn.textContent = v.available ? (isPreorder ? btn.dataset.preorder : btn.dataset.add) : btn.dataset.soldout;
      if (stockEl) {
        stockEl.classList.remove('is-low', 'is-out');
        if (!v.available) { stockEl.textContent = btn.dataset.soldout; stockEl.classList.add('is-out'); }
        else if (v.inventory_management && v.inventory_policy === 'deny' && v.inventory_quantity > 0) {
          stockEl.textContent = v.inventory_quantity + ' in stock';
          if (v.inventory_quantity <= lowStock) stockEl.classList.add('is-low');
        } else { stockEl.textContent = 'In stock'; }
      }
      const qty = $('input[name="quantity"]', form);
      if (qty && v.inventory_management && v.inventory_policy === 'deny' && v.inventory_quantity > 0) qty.max = v.inventory_quantity;
      else if (qty) qty.removeAttribute('max');
      if (v.featured_media_id) showMedia(v.featured_media_id);
      const u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState({}, '', u);
    }

    function showMedia(id) {
      const stageImg = $('[data-stage] img', root);
      const thumb = $(`[data-media-id="${id}"]`, root);
      if (!stageImg || !thumb) return;
      stageImg.src = thumb.dataset.full;
      stageImg.removeAttribute('srcset');
      $$('[data-media-id]', root).forEach((t) => t.setAttribute('aria-current', String(t === thumb)));
    }

    $$('[data-option-index] input', root).forEach((i) => i.addEventListener('change', update));
    $$('[data-media-id]', root).forEach((t) => t.addEventListener('click', () => showMedia(t.dataset.mediaId)));
    $$('[data-qty]', root).forEach((b) => b.addEventListener('click', () => {
      const input = $('input[name="quantity"]', root);
      const max = Number(input.max) || Infinity;
      input.value = Math.min(max, Math.max(1, Number(input.value || 1) + Number(b.dataset.qty)));
    }));
    update();
  });

  /* ---------- deck / list importer ---------- */
  $$('[data-deck-import]').forEach((wrap) => {
    const textarea = $('textarea', wrap);
    const parseBtn = $('[data-deck-parse]', wrap);
    const out = $('[data-deck-results]', wrap);
    const addBtn = $('[data-deck-add]', wrap);
    const totalEl = $('[data-deck-total]', wrap);
    const productCache = new Map();
    let rows = [];

    const SKIP = /^(\/\/|#|deck|main ?deck|sideboard|maybeboard|commander|companion|pok[eé]mon:?\s*\d*|trainer:?\s*\d*|energy:?\s*\d*|total cards:?\s*\d*|leader:?\s*$|characters?:?\s*\d*|events?:?\s*\d*|stages?:?\s*\d*)\s*$/i;

    function parse(text) {
      return text.split(/\r?\n/).map((l) => l.trim()).filter((l) => l && !SKIP.test(l)).map((line) => {
        const m = line.match(/^(\d+)\s*x?\s+(.+)$/i) || line.match(/^(\d+)x(\S.+)$/i);
        let qty = 1, name = line;
        if (m) { qty = Number(m[1]); name = m[2]; }
        const full = name.trim();
        // MTG Arena/MTGO "(SET) 123" and *F* flags
        let clean = full.replace(/\s*\*[A-Z]+\*\s*/g, ' ').replace(/\s*\([A-Z0-9]{2,6}\)\s*[\w-]*\s*$/i, '').trim();
        // Pokémon TCG Live "Name SET 123"
        clean = clean.replace(/\s+[A-Z]{2,4}(-[A-Z]{2})?\s+\d{1,3}[a-z]?$/, '').replace(/\s+PR-[A-Z]{2}\s+\d+$/, '').trim();
        return { qty, query: clean || full, raw: full };
      });
    }

    async function search(q) {
      const params = new URLSearchParams({
        q,
        'resources[type]': 'product',
        'resources[limit]': '6',
        'resources[options][fields]': 'title,variants.sku,tag',
        'resources[options][unavailable_products]': 'last'
      });
      const res = await fetch((AR.routes.predictive_search || root + '/search/suggest') + '.json?' + params);
      const data = await res.json();
      return ((data.resources && data.resources.results && data.resources.results.products) || []);
    }

    async function getProduct(url) {
      const handle = url.split('/products/')[1].split(/[?#]/)[0];
      if (productCache.has(handle)) return productCache.get(handle);
      const res = await fetch(root + '/products/' + handle + '.js');
      const p = await res.json();
      productCache.set(handle, p);
      return p;
    }

    function cheapestAvailable(p) {
      const avail = p.variants.filter((v) => v.available);
      return (avail.length ? avail : p.variants).slice().sort((a, b) => a.price - b.price)[0];
    }

    async function pool(items, size, fn) {
      const results = []; let i = 0;
      const workers = Array.from({ length: Math.min(size, items.length) }, async () => {
        while (i < items.length) { const idx = i++; results[idx] = await fn(items[idx], idx); }
      });
      await Promise.all(workers);
      return results;
    }

    function renderRow(row, idx) {
      const el = document.createElement('div');
      el.className = 'deck-row' + (row.matches.length ? '' : ' deck-row--missing');
      if (!row.matches.length) {
        el.innerHTML = `<span class="deck-row__qty">${row.qty}</span><div><div class="deck-row__name">${escapeHtml(row.raw)}</div><div class="deck-row__status muted">Not found in store</div></div><span></span>`;
        return el;
      }
      const productOpts = row.matches.map((m, i) => `<option value="${i}">${escapeHtml(m.title)}</option>`).join('');
      el.innerHTML = `
        <span class="deck-row__qty">${row.qty}</span>
        <div>
          <div class="deck-row__name" style="font-weight:600">${escapeHtml(row.raw)}</div>
          <div style="display:flex;gap:.4rem;flex-wrap:wrap;margin-top:.35rem">
            <select class="select" data-pick-product="${idx}" aria-label="Matching product">${productOpts}</select>
            <select class="select" data-pick-variant="${idx}" aria-label="Condition / version"></select>
          </div>
          <div class="deck-row__status" data-status="${idx}"></div>
        </div>
        <label style="font-size:.8rem;display:flex;gap:.3rem;align-items:center"><input type="checkbox" data-include="${idx}" checked> Add</label>`;
      return el;
    }

    async function fillVariants(idx) {
      const row = rows[idx];
      const sel = $(`[data-pick-variant="${idx}"]`, out);
      const status = $(`[data-status="${idx}"]`, out);
      if (!sel) return;
      const p = await getProduct(row.matches[row.productIndex].url);
      row.product = p;
      const best = cheapestAvailable(p);
      sel.innerHTML = p.variants.map((v) => `<option value="${v.id}" ${v.id === best.id ? 'selected' : ''} ${v.available ? '' : 'disabled'}>${escapeHtml(v.title === 'Default Title' ? 'Standard' : v.title)} — ${formatMoney(v.price)}${v.available ? '' : ' (sold out)'}</option>`).join('');
      row.variantId = best.available ? best.id : null;
      status.innerHTML = best.available ? '<span style="color:var(--c-success)">Available</span>' : '<span style="color:var(--c-sale)">Sold out</span>';
      updateTotal();
    }

    function updateTotal() {
      let total = 0, count = 0;
      rows.forEach((row, idx) => {
        const inc = $(`[data-include="${idx}"]`, out);
        if (!row.product || !row.variantId || (inc && !inc.checked)) return;
        const v = row.product.variants.find((x) => x.id === row.variantId);
        if (v) { total += v.price * row.qty; count += row.qty; }
      });
      if (totalEl) totalEl.textContent = `${count} cards · ${formatMoney(total)}`;
      if (addBtn) addBtn.disabled = count === 0;
    }

    parseBtn && parseBtn.addEventListener('click', async () => {
      const parsed = parse(textarea.value);
      if (!parsed.length) { toast('Paste a decklist first', true); return; }
      out.innerHTML = '<p class="muted">Searching the vault…</p>';
      parseBtn.disabled = true;
      try {
        rows = await pool(parsed, 4, async (row) => {
          let matches = await search(row.query);
          if (!matches.length && row.query !== row.raw) matches = await search(row.raw);
          return Object.assign(row, { matches, productIndex: 0, variantId: null, product: null });
        });
        out.innerHTML = '';
        rows.forEach((row, idx) => out.appendChild(renderRow(row, idx)));
        await pool(rows.map((_, i) => i).filter((i) => rows[i].matches.length), 4, fillVariants);
        const missing = rows.filter((r) => !r.matches.length).length;
        if (missing) toast(`${missing} card${missing > 1 ? 's' : ''} not found`, true);
      } catch (e) {
        out.innerHTML = '<p class="muted">Search failed. Please try again.</p>';
      } finally {
        parseBtn.disabled = false;
        updateTotal();
      }
    });

    out && out.addEventListener('change', async (e) => {
      const pp = e.target.closest('[data-pick-product]');
      const pv = e.target.closest('[data-pick-variant]');
      if (pp) { const idx = Number(pp.dataset.pickProduct); rows[idx].productIndex = Number(pp.value); await fillVariants(idx); }
      if (pv) { rows[Number(pv.dataset.pickVariant)].variantId = Number(pv.value); }
      updateTotal();
    });

    addBtn && addBtn.addEventListener('click', async () => {
      const items = [];
      rows.forEach((row, idx) => {
        const inc = $(`[data-include="${idx}"]`, out);
        if (row.variantId && (!inc || inc.checked)) items.push({ id: row.variantId, quantity: row.qty });
      });
      if (!items.length) return;
      addBtn.disabled = true;
      try {
        await addToCart(items);
        toast(`Added ${items.reduce((s, i) => s + i.quantity, 0)} cards to cart`);
      } catch (err) {
        // fall back to one-by-one so one short-stocked card doesn't block the rest
        let ok = 0; const failed = [];
        for (const item of items) {
          try { await addToCart([item]); ok += item.quantity; } catch (e2) { failed.push(item.id); }
        }
        toast(`Added ${ok} cards${failed.length ? `, ${failed.length} line(s) short on stock` : ''}`, failed.length > 0);
      } finally { addBtn.disabled = false; }
    });
  });
})();
